import styles from "./TryItLive.module.css";
import { FaVolumeUp, FaPlay } from "react-icons/fa";

const TryItLive = () => {
    return (
        <section className={styles.wrapper}>
            <div className={styles.container}>
                {/* Try It Live Card */}
                <div className={styles.card}>
                    <div className={styles.header}>
                        <FaVolumeUp className={styles.icon} />
                        <h3>Try It Live</h3>
                    </div>

                    <p className={styles.subText}>
                        Type anything and experience natural, expressive speech synthesis
                        with emotional intelligence.
                    </p>

                    <label className={styles.label}>Text Input</label>
                    <textarea
                        className={styles.textarea}
                        value="नमस्ते! your order has been shipped और delivery शुरू हो गई"
                        readOnly
                    />

                    <div className={styles.row}>
                        <div className={styles.selectBox}>
                            <label>Voice</label>
                            <select>
                                <option>Meera</option>
                                <option>Arjun</option>
                                <option>Priya</option>
                                <option>Rohan</option>
                            </select>
                        </div>

                        <div className={styles.selectBox}>
                            <label>Language</label>
                            <select>
                                <option>Hindi</option>
                                <option>English</option>
                                <option>Tamil</option>
                                <option>Telugu</option>
                            </select>
                        </div>
                    </div>

                    <button className={styles.generateBtn}>
                        <FaPlay />
                        Generate & Stream
                    </button>
                </div>

                {/* Beyond Text-to-Speech */}
                <div className={styles.infoBox}>
                    <h4>Beyond Text-to-Speech</h4>
                    <p>
                        Our TTS engine isn’t just about converting text—it’s voice synthesis
                        with soul. Natural breathing patterns, thoughtful pauses, filler
                        words like “um” and “hmm”, and emotional awareness that adapts to
                        context.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default TryItLive;
